<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Survey Details
          </p>
          <div class="panel-block">
            <span class="label">Id:</span>
            <span class="value">{{Model.Id}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Received At:</span>
            <span class="value">{{Model.ReceivedAtLocalFriendlyString || (Model.ReceivedAt | date:'medium')}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Valet Station:</span>
            <span class="value">{{Model.ValetStationName}}</span>
          </div>
          @if (Model.Rating != null) {
            <div class="panel-block">
              <span class="label">Rating:</span>
              <span class="value" style="white-space:nowrap; color:#f5a623;"
                role="img" [attr.aria-label]="Model.Rating + ' out of 5 stars'">
                @for (i of [1,2,3,4,5]; track i) {
                  <i [class]="i <= Model.Rating ? 'fa fa-star' : 'fa fa-star-o'"
                  style="margin-right:2px;" aria-hidden="true"></i>
                }
              </span>
            </div>
          }
          @if (Model.CustomerFirstName || Model.CustomerLastName) {
            <div class="panel-block">
              <span class="label">Customer Name:</span>
              <span class="value">{{Model.CustomerFirstName}} {{Model.CustomerLastName}}</span>
            </div>
          }
          @if (Model.TicketNumber) {
            <div class="panel-block">
              <span class="label">Ticket Number:</span>
              <span class="value">{{Model.TicketNumber}}</span>
            </div>
          }
          @if (Model.ValetParkingSessionId) {
            <div class="panel-block">
              <span class="label">Parking Session:</span>
              <span class="value">
                <a [routerLink]="['/valet/inventory', Model.ValetParkingSessionId]">{{Model.ValetParkingSessionId}}</a>
              </span>
            </div>
          }
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Survey Response
          </p>
          <div class="panel-block">
            <pre style="white-space: pre-wrap; word-wrap: break-word; width: 100%; margin: 0;">{{Model.Survey}}</pre>
          </div>
        </article>
      </div>
    </div>
  </div>
}
